// ============================================================
// Toast - transient notification stack (bottom-right).
// Rendered once by ToastProvider; do not mount directly.
// ============================================================
import styles from '../styles/Toast.module.css';
import clsx from '../utils/clsx';

/**
 * A toast with an action holds still while pointed at or focused (onHold), and
 * counts down again from the start when left (onRelease).
 */
function ToastItem({ t, onDismiss, onHold, onRelease }) {
  const still = t.action ? { onMouseEnter: () => onHold(t.id), onMouseLeave: () => onRelease(t.id) } : {};
  const focus = t.action ? { onFocus: () => onHold(t.id), onBlur: () => onRelease(t.id) } : {};
  return (
    <div
      role={t.type === 'error' ? 'alert' : 'status'}
      className={clsx(styles.toast, styles[t.type] || styles.info)}
      {...still}
      {...focus}
    >
      <span className={styles.message}>{t.message}</span>
      {t.action && (
        <button
          className={styles.action}
          onClick={() => {
            t.action.onClick();
            onDismiss(t.id);
          }}
        >
          {t.action.label}
        </button>
      )}
      <button className={styles.dismiss} aria-label="Dismiss notification" onClick={() => onDismiss(t.id)}>
        ✕
      </button>
    </div>
  );
}

export default function Toast({ toasts, onDismiss, onHold = () => {}, onRelease = () => {} }) {
  if (toasts.length === 0) return null;
  return (
    <div className={styles.stack} role="region" aria-label="Notifications">
      {toasts.map((t) => (
        <ToastItem key={t.id} t={t} onDismiss={onDismiss} onHold={onHold} onRelease={onRelease} />
      ))}
    </div>
  );
}
